import { Box, TextField } from "@mui/material";
import { HexColorPicker } from "react-colorful";
import { hexColorRegExp } from "./settingValueUtils";

const styles = {
  textField: {
    my: 1,
    width: "200px",
  },
};

type SettingsColorSelectorProps = {
  value: string;
  error?: boolean;
  helperText?: React.ReactNode;
  onChange: (color: string) => void;
};

export default function SettingsColorSelector({
  value,
  error,
  helperText,
  onChange,
}: SettingsColorSelectorProps) {
  // react-colorful produces #NaNNaNNaN when initialized with an empty/invalid
  // color. Always pass a valid hex so its internal HSV state is clean.
  const safeColor = hexColorRegExp.test(value) ? value : "#FFF";

  const handlePickerChange = (color: string) => {
    if (hexColorRegExp.test(color)) onChange(color);
  };

  return (
    <>
      <HexColorPicker color={safeColor} onChange={handlePickerChange} />
      <Box sx={styles.textField}>
        <TextField
          variant="outlined"
          size="small"
          value={value}
          onChange={(e) => onChange(e.target.value.trim())}
          error={error}
          helperText={helperText}
        />
      </Box>
    </>
  );
}
